import { render, staticRenderFns } from "./VShortcuts.vue?vue&type=template&id=0e8a2916&"
import script from "./VShortcuts.vue?vue&type=script&lang=js&"
export * from "./VShortcuts.vue?vue&type=script&lang=js&"
import style0 from "./VShortcuts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports